import { render, staticRenderFns } from "./LoginChangePassword.vue?vue&type=template&id=49ba0d46"
import script from "./LoginChangePassword.vue?vue&type=script&lang=js"
export * from "./LoginChangePassword.vue?vue&type=script&lang=js"
import style0 from "./LoginChangePassword.vue?vue&type=style&index=0&id=49ba0d46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports